
import type { Action } from '@empathybroker/tsclient-play/dist/models/action'
import type { PropType } from 'vue'
import type { Pagination } from '../../models/components/pagination'
import { defineComponent } from 'vue'

import { CrudActionEnum } from '../../enums'

import { UiConfirm } from '../keen-ui'
import ActionsBar from './actions-bar.component.vue'
import PaginationBar from './pagination-bar.component.vue'

export default defineComponent({
  name: 'CrudList',
  components: {
    ActionsBar,
    PaginationBar,
    UiConfirm,
  },
  props: {
    readOnly: Boolean,
    query: String,
    strictMatching: Boolean,
    strictMatchingAvailable: {
      type: Boolean,
      default: true,
    },
    selection: Array as PropType<Array<Action>>,
    configuredActions: {
      type: Array as PropType<Array<CrudActionEnum>>,
      default: () => [CrudActionEnum.CREATE, CrudActionEnum.UPDATE, CrudActionEnum.DELETE],
    },
    dataTitle: String,
    searchBoxAvailable: {
      type: Boolean,
      default: true,
    },
    enableActionsAvailable: Boolean,
    bulkEditActionAvailable: Boolean,
    forceNoDuplicatedItems: Boolean,
    forceOnlyOneItemEnabled: Boolean,
    forceOnlyOneItemEditable: {
      type: Boolean,
      default: true,
    },
    pagination: Object as PropType<Pagination>,
    itemsPerPageOptions: Array as PropType<Array<number>>,
    messages: Object,
    useAlternativePagination: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEnable(): void {
      if (this.forceOnlyOneItemEnabled) {
        this.$refs.enableDialog.open()
      } else {
        this.$emit('setEnabled', {
          enabled: true,
          callFromModal: false,
          enableDialog: this.$refs.enableDialog,
        })
      }
    },
  },
})
